module.exports = __webpack_public_path__ + "static/media/handSoap.e13b6b6b.svg";